import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import {
  resetSelectedProduct,
  setSelectedProduct,
} from '../data/subscriptionProductFamily/actions';
import { selectSubscriptionProductFamily } from '../data/subscriptionProductFamily/selectors';
import { productFamilyThemeClass } from '../constants/productFamily';

export const useSubscriptionProductFamily = () => {
  const selectedProduct = useSelector(selectSubscriptionProductFamily);
  const dispatch = useDispatch();
  const setProduct = useCallback(
    productId => {
      dispatch(setSelectedProduct(productId));
    },
    [dispatch]
  );
  return [selectedProduct, setProduct];
};

export const useResetSubscriptionProductFamilyOnExit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetSelectedProduct());
    };
  }, [dispatch]);
};

export const useSubscriptionProductFamilyTheme = () => {
  const selectedProduct = useSelector(selectSubscriptionProductFamily);
  return productFamilyThemeClass(selectedProduct);
};
